import React from 'react';
import { motion } from 'framer-motion';
import { TESTIMONIALS } from '../../data';

const Testimonials = () => {

    const SCROLL_DURATION = 30; // seconds for a full loop

    return (
        <section className="py-32 bg-[#111] overflow-hidden border-t border-white/10">
            <div className="px-6 md:px-12 mb-12 flex justify-between items-end">
                <div className="text-xs uppercase tracking-[0.2em] opacity-40">Client Endorsements</div>
                <div className="text-xs uppercase tracking-[0.2em] opacity-40 animate-pulse hidden md:block">Scrolls Infinite</div>
            </div>

            <div className="relative flex overflow-hidden mask-linear-fade">
                <motion.div
                    className="flex gap-12 md:gap-24 pl-6 md:pl-12"
                    animate={{ x: "-50%" }}
                    transition={{
                        repeat: Infinity,
                        ease: "linear",
                        duration: SCROLL_DURATION
                    }}
                >
                    {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
                        <div key={i} className="min-w-[85vw] md:min-w-[35vw] select-none opacity-80 hover:opacity-100 transition-opacity duration-300">
                            <p className="font-migra text-3xl md:text-4xl italic leading-snug mb-8 text-[#fbfbf4]">"{t.text}"</p>
                            <div>
                                <p className="font-bold text-sm uppercase tracking-widest">{t.name}</p>
                                <p className="text-xs opacity-50 uppercase tracking-widest mt-1">{t.role}</p>
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Testimonials;
